import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { UPLOAD } from "../../../../../constants/InitTypeConstants.js"
import { resetUrlResponse, uploadAction } from "../../../../../redux/actions/MasterDataAction.jsx"
import { UploadIcon } from "../../../../../component/atoms/Icons/SVG/upload.jsx"
import { RowModule } from "../../../../../component/atoms/RowModule/RowModule.jsx"
import {
  Card,
  CardBody,
  CardHeaderTitle
} from "../../../../../_metronic/_partials/controls/index.js"
import { TextInput, UploadComponent } from "../../../../../component/index.jsx"
import { useTranslation } from "react-i18next"

export const DocumentMitraIndividual = ({ isReadOnly }) => {
  const { MasterData } = useSelector((state) => state)
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const [urlKtp, setUrlKtp] = useState("")
  const [swafoto, setSwafoto] = useState("")
  const [kk, setKk] = useState("")
  const [npwp, setNpwp] = useState("")

  useEffect(() => {
    if (MasterData.urlResponseUpload) {
      if (MasterData.uploadType === UPLOAD.KTP) {
        setUrlKtp(MasterData.urlResponseUpload)
      } else if (MasterData.uploadType === UPLOAD.SWAFOTO) {
        setSwafoto(MasterData.urlResponseUpload)
      } else if (MasterData.uploadType === UPLOAD.BUSINESS_DOCUMENT) {
        setKk(MasterData.urlResponseUpload)
      } else if (MasterData.uploadType === UPLOAD.OTHER_IMAGE) {
        setNpwp(MasterData.urlResponseUpload)
      }
    }
    return () => {
      dispatch(resetUrlResponse())
    }
  }, [MasterData.urlResponseUpload, MasterData.uploadType])

  const placeholder = <UploadIcon />

  function onChangeFileKtp(e) {
    dispatch(uploadAction({ data: e, type: UPLOAD.KTP }))
  }

  function onChangeFileSwafoto(e) {
    dispatch(uploadAction({ data: e, type: UPLOAD.SWAFOTO }))
  }

  function onChangeFileKK(e) {
    dispatch(uploadAction({ data: e, type: UPLOAD.BUSINESS_DOCUMENT }))
  }

  function onChangeFileNpwp(e) {
    dispatch(uploadAction({ data: e, type: UPLOAD.OTHER_IMAGE }))
  }

  return (
    <>
      <Card className="card-custom card-shadowless">
        <CardBody>
          <RowModule>
            <CardHeaderTitle className={"my-12"}>
              {t("card_title_ktp_selfie_mitra").toUpperCase()}
            </CardHeaderTitle>
          </RowModule>
          <RowModule>
            <TextInput
              required
              editable={!isReadOnly}
              label={t("label_name_as_per_id")}
              name="name"
              placeholder={t("placeholder_input_name_as_per_ktp")}
            />
          </RowModule>
          <RowModule>
            <TextInput
              required
              editable={!isReadOnly}
              label={t("label_ktp_number")}
              type="text"
              name="ktp_no"
              placeholder={t("placeholder_input_ktp_number")}
            />
          </RowModule>
          <RowModule>
            <UploadComponent
              required
              urlParsing={urlKtp}
              name="ktp_pic_url"
              label={t("label_ktp_picture")}
              editable={!isReadOnly}
              onChange={onChangeFileKtp}
              maxSize={2048000}
              maxSizeText="2 MB"
              placeholder={placeholder}
            />
          </RowModule>
          <RowModule>
            <UploadComponent
              urlParsing={swafoto}
              name="ktp_selfie_pic_url"
              required
              label={t("label_selfie_with_ktp")}
              editable={!isReadOnly}
              onChange={onChangeFileSwafoto}
              maxSize={2048000}
              maxSizeText="2 MB"
              placeholder={placeholder}
            />
          </RowModule>
          <RowModule>
            <UploadComponent
              required={true}
              urlParsing={kk}
              name="business_document_pic_url"
              label="KK"
              editable={!isReadOnly}
              onChange={onChangeFileKK}
              maxSize={2048000}
              maxSizeText="2 MB"
              placeholder={placeholder}
            />
          </RowModule>
          <RowModule>
            <TextInput
              editable={!isReadOnly}
              label={t("label_npwp")}
              type="text"
              name="npwp_no"
              placeholder={t("placeholder_input_npwp_number")}
            />
          </RowModule>
          <RowModule>
            <UploadComponent
              urlParsing={npwp}
              name="other_image"
              label={t("label_npwp_picture")}
              editable={!isReadOnly}
              onChange={onChangeFileNpwp}
              placeholder={placeholder}
              maxSize={2048000}
              maxSizeText="2 MB"
            />
          </RowModule>
        </CardBody>
      </Card>
    </>
  )
}
